import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { arrayOf, string } from 'prop-types';
import { SessionStorageUtilities } from '../../../utilities/StorageUtilities';

export const EMPTY_ARRAY = [];

export const FILTER_TITLE = i18n._(t`Type`);
export const STATE_TYPE = arrayOf(string);

export const getDefaultOptions = (filterId, defaultOptions) => {
    return { [filterId]: defaultOptions };
};

export const getLastType = (filterId, defaultTypeValues) => {
    const lastType = SessionStorageUtilities.getJSONValue(filterId);
    if (!lastType) {
        return defaultTypeValues;
    }

    return lastType;
};

export const createTypeUtils = (typeNames) => {
    return {
        objects: Object.entries(typeNames).map(([value, name]) => ({ name, value })),
        values: Object.keys(typeNames),
        getName: (typeValue) => typeNames[typeValue] ?? typeValue,
    };
};

export function getTypeFilterStateServiceFactory(
    title,
    paramName,
    getLastTypeFn,
    getTypeNameFn,
    isAllowSelectionEmpty
) {
    return (filterId) => {
        const TypeFilterStateService = {
            // eslint-disable-next-line no-unused-vars
            createWithEncodedState(encodedState, dataService) {
                return TypeFilterStateService.decode(encodedState);
            },

            // eslint-disable-next-line no-unused-vars
            createWithDefaultState(dataService) {
                // Allow Selection Empty, which means default value is empty
                if (isAllowSelectionEmpty) {
                    const lastType = SessionStorageUtilities.getJSONValue(filterId);
                    // When not found in session storage, just use default [] as default value to find all types
                    if (!lastType) {
                        return [];
                    }
                }

                return getLastTypeFn();
            },

            createState(encodedFilterState, dataService) {
                const encodedState = encodedFilterState?.[filterId];
                return encodedState
                    ? this.createWithEncodedState(encodedState, dataService)
                    : this.createWithDefaultState(dataService);
            },

            /*
             * Transformation functions
             */
            parameterize(state) {
                return {
                    [paramName]: state.join(','),
                };
            },

            encode(state) {
                return state?.join(',') || '';
            },

            decode(encodedState) {
                return (encodedState || '').split(',');
            },

            summarize(state) {
                const summary = state.map(getTypeNameFn).sort().join(', ');
                return {
                    title,
                    value: summary,
                    shortValue: summary,
                };
            },
        };

        return TypeFilterStateService;
    };
}
